module.exports = __webpack_public_path__ + "img/kkbs_corner.0d14ede5.svg";